const e=Object.freeze({small:"(max-width: 64em)",medium:"(max-width: 108em)",large:"(min-width: 108em)"});export{e as SCREEN_SIZES};
//# sourceMappingURL=useMediaQuery.constants.js.map
